export default __webpack_public_path__ + "static/kraken-f9b9794a6ebb09421bf0b9bbd77ff965.svg";